import { setWidgetConfig } from '@/config/defaultConfig';
import { isEmpty } from '@/services/object';
import { createApp } from 'vue';
import App from './App.vue';
import { init } from '@/pages/init.js';

function render(urlPath, widgetParams) {
  setWidgetConfig(widgetParams);
  const app = createApp(App);

  init(urlPath, app, widgetParams.containerId || 'rtt', true);
}

const urlToParams = urlString => {
  const url = new URL(urlString);

  return {
    hashPath: url.hash.substring(1),
    params: Object.fromEntries(new URLSearchParams(url.search).entries())
  };
};

const getParams = () => {
  // if params are defined on widget.js url take these
  const { hashPath, params } = urlToParams(import.meta.url);
  if (hashPath || !isEmpty(params)) return { hashPath, params };

  // else check for params on window url
  return urlToParams(document.URL);
};

const { hashPath, params: widgetParams } = getParams();
if (widgetParams.autoRender !== 'false') {
  render(hashPath, widgetParams);
}

window.betterTracking = { render };
export default { render };
